<!-- The one top-right overlay for canvas corner panels (Measure Drawing, Set
     Scale from Dimension). An absolutely positioned wrapper that reserves no
     layout space and lets clicks through; each child card opts back into
     pointer events itself. Panels are slotted in priority order and a closed
     panel renders nothing, so the open ones stack in a column with whoever is
     first taking the top spot — never overlapping, with no pixel offsets to
     measure. New corner panels must mount inside this container, not float
     their own absolute wrapper. -->
<div class="absolute top-0 right-0 p-4 z-30 pointer-events-none text-xs flex flex-col items-end gap-2">
  <slot />
</div>
